import { gql } from '@apollo/client';

export const GET_ARCHIVE_SEASONS = gql`
  query GetArchiveSeasons {
    seasons {
      id
      league
      season
      year
      teams(where: { champion: { _eq: true } }) {
        color
        colorSecondary
        division
        id
        name
        captainPlayer {
          firstName
          id
          lastName
        }
      }
    }
  }
`;
